import { PayloadAction } from '@reduxjs/toolkit';
import { DesignData, DesignState } from 'src/store/design/types';

const setDesignStructureReducer = (state: DesignState, action: PayloadAction<DesignData|undefined>) => {
  state.structure = action.payload;
};

export default setDesignStructureReducer;
